/**
 * GiftListContainer
 * --
 */
import React from 'react';
import GiftListPresenter from './GiftListPresenter';

const GiftListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <GiftListPresenter />
    </>
  );
};

export default GiftListContainer;
